<div
    #securityIcon
    class="security-info-content cc-hyperlink {{ cssClass }}"
    title=""
    [ngClass]="iconColor"
    (mouseenter)="startSchedule()"
    (mouseleave)="stopSchedule()"
>
    <i [ngClass]="iconClass"></i>
</div>
<dx-popover
    *ngIf="securityInfoVisible"
    [width]="350"
    [maxHeight]="500"
    [minHeight]="60"
    [target]="securityIcon"
    [showTitle]="false"
    [closeOnOutsideClick]="true"
    [(visible)]="securityInfoVisible"
    (onShown)="ignoreSchedule($event)"
    (onHidden)="restartSchedule()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view>
            <ng-container *ngFor="let info of securityInfoGroup">
                <strong>{{ info.name }}</strong>
                <div [innerHTML]="info.htmlText | ccSafeHtml"></div>
                <br />
            </ng-container>
        </dx-scroll-view>
    </div>
</dx-popover>
